import React  from 'react';
import PropTypes from 'prop-types';
import { courseBuilderConstants } from '../../../../utils/races/CourseBuilderConstants';
import {colors} from '../../../../shared/styles';

export const LegDistanceKindSelect = ({value, onChange, t}) => {

  // const buildOptions = () => {
  //   return (courseBuilderConstants(t).BYO_LEG_DISTANCES).map((d) => {
  //     return <MenuItem key={d.val} value={d.val} primaryText={d.caption} className={'distance-type-items'}/>
  //   });
  // };

  // return (
  //   <SelectField
  //     style={{verticalAlign:'middle', width:130}}
  //     floatingLabelText={t('Distance Type')}
  //     floatingLabelStyle={{color: colors.darkGrey}}
  //     maxHeight={200}
  //     onChange={onChange}
  //     value={value}
  //     id={'distance-type'}>
  //     {buildOptions()}
  //   </SelectField>);

  return null;
};

LegDistanceKindSelect.propTypes = {
  t: PropTypes.func
}; // TODO: still needed?



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/LegDistanceKindSelect.js
 **/